import _ from "lodash"
import Store from '../store'

export const getCurrentScreenType = () => {
    const designMode = Store.getState()?.interactableState?.uiDesignMode
    let screenType = 'standard'

    if(designMode) {
        screenType = designMode //if designMode is set, it contains the screen type
    } else {
        screenType = getHardwareScreenType()
    }
    // always return lower case and let people adjust case from there as desired
    return screenType.toLowerCase()
}

export const getHardwareScreenType = () => {
    let screenType = 'standard'
    if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
        screenType = 'ipad'
    }
    return screenType;
}

export const compatibleWithCurrentScreenType = (item) => {
    const currentScreenType = getCurrentScreenType()
    if(item.screenType == null)
    {
        //item doesn't have a screen type which means its legacy and should be treated as standard screen type
        return currentScreenType === 'standard'
    } else {
        return item.screenType === currentScreenType
    }
}

export const getCompatibleWindows = (supportedScreenType, windowConfigArr) => {
    return getCompatibleItems(supportedScreenType, windowConfigArr)
}

export const getCompatibleScreens = (supportedScreenType, screenConfigArr) => {
    return getCompatibleItems(supportedScreenType, screenConfigArr)
}

export const getCompatibleWorkflows = (supportedScreenType, workflowConfigArr) => {
    return getCompatibleItems(supportedScreenType, workflowConfigArr)
}

export const getCompatibleQuickAccess = (supportedScreenType, QuickAccessConfigArr) => {
    return getCompatibleItems(supportedScreenType, QuickAccessConfigArr)
}

const getCompatibleItems = (supportedScreenType, ItemsArr = []) => {
    return ItemsArr
        .map(item => item.screenType == null ? {...item, screenType: 'standard'} : item) // migrate old items with no screen type to be 'standard'
        .filter(item => item.screenType === supportedScreenType)
}